import {
  AppBar,
  IconButton,
  Toolbar,
  Typography,
  useTheme,
} from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import * as React from 'react'
import { AnalyticService } from '../../lib/analytics/analyticService'
import _ from 'lodash'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

interface IDialogProps {
  classes?: any // for with styles
  fullWidth?: boolean
  fullScreen: boolean
  open: boolean
  title: any
  hideTitleBar?: boolean
  hideCancelButton?: boolean
  content: any
  contentPadding?: string
  dialogStyle?: React.CSSProperties
  contentStyle?: React.CSSProperties
  appbarStyle?: any
  closeButtonStyle?: React.CSSProperties
  onRequestClose: () => void
  disableBackgroundClickClose?: boolean
  keepMounted?: boolean
}

const ResponsiveDialog = (props: IDialogProps) => {
  // const [modalHash] = React.useState(_.uniqueId("dialog-"));
  const {
    fullScreen,
    open,
    title,
    content,
    contentPadding,
    appbarStyle,
    onRequestClose,
  } = props
  const hideTitleBar = props.hideTitleBar || false
  const contentStyle = props.contentStyle || {}
  const dialogStyle = props.dialogStyle || {}

  const theme = useTheme()

  React.useEffect(() => {
    if (props.open) {
      AnalyticService.dialogOpened({
        title: props.title,
      })
    }
  }, [])

  // useModalBackButtonNavigation({
  //   onClose: props.onRequestClose,
  //   hash: modalHash, // or use any name that you want
  //   isModalOpen: props.open,
  // });

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        keepMounted={props.keepMounted}
        open={open}
        fullWidth={props.fullWidth}
        style={{ ...dialogStyle }}
        onClose={_e => {
          AnalyticService.dialogClosed({
            title: props.title,
          })
          if (!props.disableBackgroundClickClose) {
            onRequestClose()
          }
        }}
        aria-labelledby="pledre-responsive-dialog"
      >
        {!hideTitleBar && (
          <AppBar
            style={{
              // background: theme.palette.secondary.
              background: `linear-gradient(to right, ${theme.palette.primary.dark}, ${theme.palette.warning.dark})`,
              boxShadow: 'none',
              borderBottom: '1px solid #e0e0e0',
              position: 'relative',
              ...appbarStyle,
            }}
          >
            <Toolbar
              style={{
                display: 'flex',
              }}
            >
              {!props.hideCancelButton && (
                <IconButton
                  style={{
                    color: '#fff',
                    ...props.closeButtonStyle,
                  }}
                  onClick={_e => {
                    onRequestClose()
                  }}
                  aria-label="Close"
                  size="large"
                >
                  <ArrowBackIcon fontSize={'medium'} />
                </IconButton>
              )}
              <Typography
                style={{
                  color: appbarStyle ? appbarStyle.titleColor : '',
                  fontSize: '18px',
                  fontWeight: 700,
                  flex: 1,
                }}
              >
                {title}
              </Typography>
            </Toolbar>
          </AppBar>
        )}
        <DialogContent
          style={{ padding: contentPadding || 'auto', ...contentStyle }}
        >
          {content}
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default ResponsiveDialog
